import { Accordion, AccordionSummary, Skeleton } from '@mui/material';
import Typography from '@mui/material/Typography';
import { ExpandMoreOutlined, MoreVertOutlined } from '@mui/icons-material';
import Box from '@mui/material/Box';

interface Props {
    pl?: number;
}

const AccordionItemSkeleton = ({ pl = 1 }: Props) => (
    <Accordion
        disableGutters
        sx={{
            borderRadius: '0 !important',
            boxShadow: 0,
            '&::before': {
                bgcolor: 'white',
            },
        }}
    >
        <AccordionSummary
            disabled={true}
            expandIcon={<ExpandMoreOutlined />}
            sx={{
                p: 0,
                pl,
                minHeight: 0,
                flexDirection: 'row-reverse',
                gap: 1,
                '& .MuiAccordionSummary-content': {
                    m: 0,
                },
            }}
        >
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: '1fr auto',
                    alignItems: 'center',
                    gap: 1,
                    flexGrow: 1,
                }}
            >
                <Typography justifySelf={'start'} fontSize={14} textTransform={'capitalize'}>
                    <Skeleton
                        sx={{
                            width: 100,
                        }}
                    />
                </Typography>

                <Box>
                    <Box
                        id={'client-menu-button'}
                        sx={{
                            borderRadius: 2,
                            p: 0.5,
                            m: 0.5,
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'action.active',
                        }}
                    >
                        <MoreVertOutlined />
                    </Box>
                </Box>
            </Box>
        </AccordionSummary>
    </Accordion>
);

export default AccordionItemSkeleton;
